
import { ParallaxEffect, ParallaxContext } from './ParallaxEffect';
import { ParallaxEffectType } from '@/types';

export class ParallaxRegistry {
    private static effects: Map<string, ParallaxEffect> = new Map();

    public static register(type: string, effect: ParallaxEffect) {
        this.effects.set(type, effect);
    }

    public static get(type: string): ParallaxEffect | undefined {
        return this.effects.get(type);
    }

    public static render(type: string, pc: ParallaxContext) {
        const effect = this.effects.get(type);
        if (effect) {
            effect.render(pc);
        }
    }
}
